import TopNav from './TopNav';
import BottomNav from './BottomNav';

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <TopNav />
            <main className="pb-24 md:pb-8">
                {children}
            </main>
            <BottomNav />
        </div>
    );
}
